import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar.js';
import Footer from './components/Footer.js';
import Home from './pages/Home.js';
import Features from './pages/Features.js';
import Docs from './pages/Docs.js';
// import Pricing from './pages/Pricing.js';
import About from './pages/About.js';
import Contact from './pages/ContactUs.js';
import { ToastContainer } from 'react-toastify';
import MerchantPortal from './pages/Dashboard.js';

export default function App() {
  return (
    <>
    <ToastContainer />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/docs" element={<Docs />} />
        {/* <Route path="/pricing" element={<Pricing />} /> */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portal" element={<MerchantPortal />} />
      </Routes>
      <Footer />
    </>
  );
}